import { useRef, useEffect } from 'react';
import { trackHeapEvent } from '@shared_modules/custom-heap-tracking-attributes';

// Tracks the amount of time borrower spent on the page.
const useTimeOnPage = ({ eventName, payload }) => {
  const nowRef = useRef(undefined);
  const payLoadRef = useRef(payload);

  useEffect(() => {
    if (!nowRef.current) nowRef.current = Date.now();
    return () => {
      trackHeapEvent(eventName, 'page stats', {
        timeOnPageInSec: (Date.now() - nowRef.current) / 1000,
        ...payLoadRef.current,
      });
    };
  }, []);

  useEffect(() => {
    payLoadRef.current = payload;
  }, [payload]);
};

export default useTimeOnPage;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');